
import React from 'react';
import '../App.css';

const Listajunaeb = () => {
  const pdfFiles = [
    { title: "Minuta Mes de Abril 2026", url:"/pdfs/Minuta Abril 2026.pdf " },
    { title: "Minuta Mes de Mayo 2026", url:"/pdfs/Minuta Mayo 2026.pdf" },
    { title: "Minuta Mes de Junio 2026", url:"/pdfs/Minuta Junio 2026.pdf " },
    /*{ title: "Minuta Mes de Julio 2026", url:"/pdfs/Minuta Julio 2026.pdf" },
    { title: "Minuta Mes de Agosto 2026", url:"/pdfs/Minuta Agosto 2026.pdf" },
    { title: "Minuta Mes de Septiembre 2026", url:"/pdfs/Minuta Septiembre 2026.pdf" },
    { title: "Minuta Mes de Octubre 2026", url:"/pdfs/Minuta Octubre 2026.pdf" },
    { title: "Minuta Mes de Noviembre 2026", url:"/pdfs/Minuta Noviembre 2026.pdf" },
    { title: "Minuta Mes de Diciembre 2026", url:"/pdfs/Minuta Diciembre 2026.pdf" }, */
   
  ];

  return (
    <div id="Listajunaeb" className="junaeb-container">
      <h2 className="junaeb-title">Alimentación Junaeb</h2>
      <div className="pdf-list-container">
        {pdfFiles.map((pdf, index) => (
          <div key={index} className="pdf-card">
            <a href={pdf.url} target="_blank" rel="noopener noreferrer">
              {pdf.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Listajunaeb;

